var _excluded = ["pictogram", "title", "description", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import { DATA_SPACER } from "#library/constants/enums";
import { Pictogram, PICTOGRAM_SIZES } from "#library/components/Pictogram/Pictogram";
import { Text, TEXT_TYPES, TEXT_WEIGHTS, TEXT_ALIGNS } from "#library/components/Text/Text";
import { ButtonEmptyState } from "./Button";
import { LinkEmptyState } from "./Link";
import { propTypes, defaultProps } from "./types";
import styles from "./emptyState.module.css";
export var EmptyState = function EmptyState(_ref) {
  var pictogram = _ref.pictogram,
    title = _ref.title,
    description = _ref.description,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: styles["jds-EmptyState"]
  }, restProps), /*#__PURE__*/React.createElement("article", {
    className: styles["jds-EmptyState__content"]
  }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement(Pictogram, {
    xlinkHref: "#".concat(pictogram.id),
    size: PICTOGRAM_SIZES.LARGE
  })), /*#__PURE__*/React.createElement(Text, {
    type: TEXT_TYPES.SUBHEAD,
    weight: TEXT_WEIGHTS.BLACK,
    align: TEXT_ALIGNS.CENTER,
    resetSpacing: true,
    "data-spacer": DATA_SPACER.TOP_200
  }, title), /*#__PURE__*/React.createElement(Text, {
    align: TEXT_ALIGNS.CENTER,
    resetSpacing: true,
    "data-spacer": DATA_SPACER.TOP_100
  }, description), children && /*#__PURE__*/React.createElement("footer", {
    "data-spacer": DATA_SPACER.TOP_200
  }, children)));
};
EmptyState.propTypes = propTypes;
EmptyState.defaultProps = defaultProps;
EmptyState.Button = ButtonEmptyState;
EmptyState.Link = LinkEmptyState;